import {
    HttpResponse,
    StateOfCapitalModel,
    QueryModel,
    RequestParams,
    StateOfCapitalModelIEnumerableApiResultSuccess,
    StateOfCapitalModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse} from '@/libs/core/crud/crud-service';

export class StateOfCapitalDataService implements CrudService<StateOfCapitalModel, StateOfCapitalModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<StateOfCapitalModel>): Promise<CrudListResponse<StateOfCapitalModel>> {
        return ApiService.api.getStateOfCapitalBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<StateOfCapitalModel>> {
        return ApiService.api.getStateOfCapitalById(id, params);
    }

    create(item: StateOfCapitalModel, params?: RequestParams): Promise<CrudResponse<StateOfCapitalModel>> {
        return ApiService.api.insertStateOfCapital(item, params);
    }

    update(item: StateOfCapitalModel, params?: RequestParams): Promise<StateOfCapitalModel> {
        return ApiService.api.updateStateOfCapital(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<StateOfCapitalModel> {
        return ApiService.api.patchStateOfCapital(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<StateOfCapitalModel>): Promise<CrudListResponse<StateOfCapitalModel>> {
        return ApiService.api.deleteStateOfCapital(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<StateOfCapitalModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
